export enum TimeRangeName {
  START_TIME = 'startTime',
  END_TIME = 'endTime',
}

export enum TypeOfChange {
  CHOICE_AVAILABILITY_CHANGE = 'menu_management_pandora.choice_availability_change',
}
